import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CanvasContentService {
  private selectedReportSource = new BehaviorSubject<any>(null);
  selectedReport$ = this.selectedReportSource.asObservable();

  constructor() { }

    setSelectedReport(report: any): void {
    this.selectedReportSource.next(report);
  }

  clearSelectedReport(): void {
    this.selectedReportSource.next(null);
  }
}
